import IconHelper from "../../Helpers/IconHelper";
import ImageHelper from "../../Helpers/ImageHelper";
import BrandingPackagesData, { CollateralPackagesData } from "../PackagesData/BrandingPackagesData";
import ECommercePackagesData from "../PackagesData/ECommercePackagesData";
import SEOPackagesData from "../PackagesData/SEOPackagesData";
import VideoAnimationPackagesData from "../PackagesData/VideoAnimationPackagesData";
import WebDesignPackagesData from "../PackagesData/WebDesignPackagesData";
import PortfolioDataLogo from "../PortfolioData/PortfolioDataLogo";
import PortfolioDataSocialMediaDesign from "../PortfolioData/PortfolioDataSocialMediaDesign";
import PortfolioDataWeb from "../PortfolioData/PortfolioDataWeb";
import PortfolioDataUiUx from "../PortfolioData/PortfolioDataUiUx";
import PortfolioDataPoster from "../PortfolioData/PortfolioDataPoster";
import PortfolioDataOther from "../PortfolioData/PortfolioDataOther";
import PortfolioImagesData from "./PortfolioImagesData";

const ServicesPageData = {
  staffAugmentation: {
    id: "s22",
    pageName: "Staff Augmentation & Dedicated Teams",
    menuName: "Services",
    slug: "staff-augmentation",
    titleLine: "Extend Your Team, Not Your Headcount",
    captionLine:
      "Senior Product, UX, and Frontend talent embedded in your team — scale up or down as your roadmap shifts.",
    description: [],
    tagLine: [
      "Senior Product, UX & Frontend Talent",
      "Embedded in Your Team",
    ],
    bannerImg: ImageHelper.HeroImage,
    bannerTitle: "A faster way to add senior capacity",
    bannerDesc: [
      "Hiring takes months you don't have, and a full agency engagement hands your roadmap to someone else. Staff augmentation is the middle path: a senior Product, UX, or Frontend specialist joins your team directly — your standups, your tools, your roadmap — for as long as you need the extra capacity.",
      "Need more than one role? A dedicated team works the same way at a larger scale: a small pod assembled around your specific gap, reporting into your team instead of running a separate workstream alongside it.",
    ],
    pageModIntro: [],
    QuickAcationBtn: "Talk to Us",
    portfolioSlider: {
      portfolioTitle: "Product & UX Design",
      portfolioCaption: "Work We've Shipped",
      portfolioImages: PortfolioImagesData.uiUxDesignPortfolio,
    },
    servicePortfolio: {
      servicePortfolioTitle: "Real products, not mockups",
      servicePortfolioCaption: "SHIPPED WORK",
      servicePortfolioData: PortfolioDataUiUx,
    },
    keyHighlights: {
      question: "How does this actually work?",
      description:
        "Staff augmentation only works if it feels like hiring, not outsourcing. Here's what that means in practice.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "You Stay in Control",
          desc: "The placement works your hours, joins your standups, and reports to your lead — your roadmap sets the priorities, not ours.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Senior From Day One",
          desc: "Every placement has shipped real products already — no ramp-up spent training someone on the fundamentals.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Scale When You Need To",
          desc: "Start with one role, add a second, or step down to project-based work — the engagement adjusts to your roadmap, not a fixed contract term.",
        },
      ],
    },
  },
  webDesign: {
    id: "s01",
    pageName: "Web Design",
    menuName: "Services",
    slug: "web-design",
    titleLine:
      "A Stunning Website To Welcome Your Customers, Designed By TZ Creation With Love",
    captionLine:
      "Make your customers’ visit memorable and rewarding, made possible by TZ Creation – a leading web design company.",
    description: [],
    tagLine: ["Modern Web Design Services", "Developed to Grow Your Business"],
    bannerImg: ImageHelper.webDesign,
    bannerTitle: "Your website is the face of your business.",
    bannerDesc: [
      "Web Design with your customer in mind. Modern web design is more involved than creating an attractive website. Consideration of user experience, search engine optimization, ease of use, and technical details are just a few elements that are involved in developing a website that is designed to perform in today’s competitive marketplace.",
      "Our web design & development team has established a host of effective services to facilitate the growth of your business. These include WordPress websites and eCommerce solutions focused on usability and responsive design, creative br /anding solutions that inject personality into your business, and custom programming for ideas that you need help br /inging to fruition.",
    ],
    pageModIntro: [],
    portfolioSlider: {
      portfolioTitle: "Web Design",
      portfolioCaption: "Our Web Designs",
      portfolioImages: PortfolioImagesData.webDesignPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR Website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "How will you be benefited?",
      description:
        "At this point, you have every one of your pages characterized and know how they show the web application guest, so it's an ideal opportunity to ensure everything works so that when you have a web application visitor, they don't get anything that may loosen their interest. Consolidate manual perusing of the web application on gadgets with computerized web application visitors to recognize everything from client experience issues to direct broken connections.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Modern Coding",
          desc: "Our web design & development team utilizes up-to-date coding practices with clean HTML5 and CSS3.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Optimized Speed",
          desc: "Fast load times : happy customers. Google has made it clear that they prefer websites that respond quickly.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Mobile-Friendly",
          desc: "All of our websites are developed to look and perform beautifully on every device your users are viewing it from.",
        },
      ],
    },
  },
  psdToHtml: {
    id: "s02",
    pageName: "PSD To HTML",
    menuName: "Services",
    slug: "psd-to-html",
    titleLine: "Premium PSD to HTML Conversion Services",
    captionLine:
      "We hand code your designs into pixel perfect, SEO friendly and fast loading HTML.",
    captionLine2:
      "Mobile Friendly | NDA Agreement | Money-Back Guarantee (Terms Apply)",
    description: [
      "Turning a static design into a working website is where a lot of the value gets lost — spacing drifts, fonts don't match, and the site that ships looks like a rough copy of the design instead of the design itself. We hand-code every PSD to HTML conversion pixel by pixel, so what you approved in the design file is exactly what visitors see live, built on clean markup that loads fast and holds up well for search engines.",
      "We build with the same coding standards on every project — semantic HTML, layouts that hold up responsively across devices, and structure that's easy to extend or hand off to a CMS later if you need it down the line.",
    ],
    tagLine: [
      "With Us You Get More Than Just Conversion",
      " Of Photoshop design to HTML",
    ],
    bannerImg: ImageHelper.PsdToHtml,
    bannerTitle:
      "Choose Our PSD to HTML Services to Get A Fully Customized & Dynamic Design",
    bannerDesc: [
      "Our developers are versed in the process of converting your designs perfectly. Whether it is Sketch, PSD design, PDF, Adobe XD, PNG, JPG, AI, EPS or any similar preference, we treat every design format equally. Our fervent team follows effective coding standards to get the same naming convention for every use and hence meets the expectations of the clients at par. We input custom form elements plus WCAG 2.0 for web accessibility to create a fresh HTML code that speaks out. You can also ask to incorporate video in your image background to add creativity at its best.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "PSD to HTML Conversion",
      portfolioCaption: "Our Web Designs",
      portfolioImages: PortfolioImagesData.psdToHtmlPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "What We Value Most ?",
      description:
        "As a leading PSD to HTML Company, we take extra steps to meet your design requirements.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Usability",
          desc: "Usability is one the key parameter in determining the website engagement, It is determined by how the user interacts with your website. We have the expertise in improving the various parameters of app and website usability like loading speed, making site responsive and site interface.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Functionality",
          desc: "Functionality defines the capability of any app or website. We work closely with you to make sure every interactive element in the converted HTML behaves exactly as the design intended, and matches your actual requirements before we call it done.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Performance",
          desc: "Performance is the benchmark that decides where your app and website stand in terms of ROI. We know what typically drags a converted page down — bloated markup, unoptimized images, render-blocking scripts — and we build to avoid those issues from the start rather than patching them after launch.",
        },
      ],
    },
  },
  appDev: {
    id: "s03",
    pageName: "App Development",
    menuName: "Services",
    slug: "app-development",
    titleLine: "Experienced Designers",
    captionLine:
      "we design and build native, hybrid, and cross-platform mobile apps that people actually keep on their phone.",
    captionLine2: "iOS & Android | NDA Agreement | Money-Back Guarantee (Terms Apply)",
    description: [
      "The leading concern for every new consumer that wants to buy your product or hire your services is convenience. With our mobile app development and design services, you can provide them with the sense of comfort that they so desperately crave. Our designers embody your brand's identity in a way that ensures that your designer is in perfect sync with your creative vision. We create apps that maximize your business's growth potential.",
    ],
    tagLine: ["Do What You Want!"],
    bannerImg: ImageHelper.AppBanner1,
    bannerTitle: "Why should you create a Mobile App?",
    bannerDesc: [
      "The leading concern for every new consumer that wants to buy your product or hire your services is convenience. With our mobile app development and design services, you can provide them with the sense of comfort that they so desperately crave. Our designers embody your brand's identity in a way that ensures that your designer is in perfect sync with your creative vision. We create apps that maximize your business's growth potential.",
    ],
    portfolioSlider: {
      portfolioTitle: "Custom Mobile Application Designs",
      portfolioCaption: "OUR PAST PROJECTS",
      portfolioImages: PortfolioImagesData.appDevPortfolio,
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our design studio",
      servicePortfolioCaption: "OUR APP DESIGN PORTFOLIO",
      servicePortfolioData: PortfolioDataUiUx,
    },
    keyHighlights: {
      question: "What exactly is it that we do?",
      description:
        "Our mobile application design and development portfolio span far and wide; this allows us to provide our clients with various options that suit their needs best to make sure that we offer you a better idea of what you may need from us.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Native Apps",
          desc: "These apps are by far the most popular ones that our clients opt for. This is because these apps are fast and are the best in achieving a singular purpose. We create native apps that utilize your device's potential to the fullest, and we make sure that your app is the best it can be at fulfilling the purpose it is required to fulfill. Native Apps are designed specifically for one type of operating system; this can result in problems if you want to switch to a different operating system.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Hybrid Apps",
          desc: "As the name suggests, these apps are a combination of the other two types of websites. This means that they combine the best functions of the different two types of websites and enhances them. They provide the most level of customization and procedures, which allow you to serve your customers to the best of your abilities. Our app designers are the best in these apps as they have the most experience creating these.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Web Apps",
          desc: "These apps tend to behave more like a website than conventional types of apps. This means that they have a user interface similar to that of a website. They are snappier and are lightweight as they do not store that much data in your device's storage, and all the data is stored in the cloud. As the app opens, the app loads up stuff in real-time, the things you want to see. These types of apps are the best ones to use for eCommerce platforms similar to Amazon and eBay.",
        },
      ],
    },
  },
  branding: {
    id: "s04",
    pageName: "Branding",
    menuName: "Services",
    slug: "branding",
    titleLine: "Customized",
    captionLine: "We design patterns and make values for your brand",
    captionLine2: "",
    description: [
      "Resourceful designing plays a very important role in the triumph and development of your business. It sets the basics and fundamentals of the core purpose of your business. The TZ Creation, being a top branding agency, know the ways to make your brand grow, and we are well experienced in dealing with designing and creating standards for branding.",
    ],
    tagLine: [
      "With Us You Get More Than Just Conversion",
      " Of Photoshop design to HTML",
    ],
    bannerImg: ImageHelper.Branding,
    bannerTitle: "We produce thought-provoking taglines",
    bannerDesc: [
      "Taglines can help your brand in being at the center of attention among the consumers. They provide your brand a distinct element that we can use in the longer run. Catchy taglines play a very crucial role in the marketing strategy, too; they are the main ingredient on which the entire social media marketing and branding depend. We provide professional branding services in this regard, too, that can help your business a lot in making a name for itself, thereby turning out to be a cash cow for you.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "OUR CREATIVE PORTFOLIO",
      portfolioCaption: "CUSTOM STATIONERY DESIGNS",
      portfolioImages: PortfolioImagesData.BrandingPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Custom Branding Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "BUDGET-FRIENDLY",
      spData: BrandingPackagesData,
      spShortDescription:
        "Our branding services are the most sought after in the market and that is not without reason. We have improved cashflows for various businesses in the market, allow us to do the same for you!",
      spDescription:
        "The importance of an integrated brand can be found out if we take a look at all the successful brands. The only common feature in their success stories is that they all were somehow integrated. It is very crucial for your brand to be integrated into every aspect. This is where we come in; we deliver business card design online that can help you a lot in integrating your brand logically.",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR Website PORTFOLIO",
      servicePortfolioData: PortfolioDataSocialMediaDesign,
    },
    keyHighlights: {
      question: "How We Perform?",
      description:
        "We provide the best brand development strategy and corporate brand identity that are essential for your business. Being a team of professional brand developers, we make sure that we take into consideration whatever is important before starting to go for any major step. We offer custom stationery design and brand identity design, the things that your brand will be needing as part of its marketing strategy.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Define",
          desc: "Definition of the purpose and core values of the brand is very crucial in the successful execution of branding and marketing plan. The brand needs to have a thorough definition of the purpose and the way of being perceived among the consumers; it is significant for the popularity of your name in the market. What we offer is the best brand development strategy that you will be needing in defining the purpose of your brand.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Organize",
          desc: "Organization of every involved element is also very important as it should be apt and sharp. Once the definition has been decided and executed, what the brand will need is to organize all the factors that are involved. What we provide are the methods to organize all the features that are involved in your branding plan. We are well known for organizing these elements, and we can help you a lot in this regard, we assure you of this fact.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Communicate",
          desc: "Communication is very crucial in branding. Whatever you have decided in terms of the definition of your brand, communication should be carried out in that particular way. It is very important in terms of reliability and credibility of your brand; it can get you, customers, in a matter of time. This is where we come in; we have a team of specialists that can communicate your values in an incredible manner. Our team is the most experienced on in the market.",
        },
      ],
    },
  },
  customWebDesign: {
    id: "s05",
    pageName: "Custom Web Design",
    menuName: "Services",
    slug: "custom-web-design",
    titleLine:
      "Custom Website Design Service that is built to educate, inspire, attract & convert.",
    captionLine: "Build your brand with, Creative Website Design",
    captionLine2: "",
    description: [],
    tagLine: ["The ABC of Custom Web Design"],
    bannerImg: ImageHelper.CustomWebDesign,
    bannerTitle: "What is a Custom Web Design?",
    bannerDesc: [
      "Custom web design is much more than the color scheme, images, and fonts of your website. A custom web design is the process of learning and understanding about your business, and applying a sound process of strategy, user experience, design execution, programming, and marketing to form a successful online business presence. Every aspect of your website is built specifically for your organizational goals. We believe this service is the most important in creating an effective digital asset with a highly positive ROI.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Our Custom Web Designs",
      portfolioCaption: "Web Designs",
      portfolioImages: PortfolioImagesData.psdToHtmlPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Custom Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site.",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "How will you be benefited?",
      description:
        "At this point, you have every one of your pages characterized and know how they show the web application guest, so it's an ideal opportunity to ensure everything works so that when you have a web application visitor, they don't get anything that may loosen their interest. Consolidate manual perusing of the web application on gadgets with computerized web application visitors to recognize everything from client experience issues to direct broken connections.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Modern Coding",
          desc: "Our web design & development team utilizes up-to-date coding practices with clean HTML5 and CSS3.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Optimized Speed",
          desc: "Fast load times : happy customers. Google has made it clear that they prefer websites that respond quickly.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Mobile-Friendly",
          desc: "All of our websites are developed to look and perform beautifully on every device your users are viewing it from.",
        },
      ],
    },
  },
  ecommerceWebsite: {
    id: "s06",
    pageName: "Ecommerce Website",
    menuName: "Services",
    slug: "ecommerce-website",
    titleLine: "PROFESSIONAL",
    captionLine: "Big Commerce Is The Way To Go!",
    captionLine2: "",
    description: [
      "We build ecommerce websites designed to help your brand thrive and outperform competitors online.",
    ],
    tagLine: ["PERFECT STARTING POINT TO"],
    bannerImg: ImageHelper.Ecommerce,
    bannerTitle: "Custom E-commerce website design",
    bannerDesc: [
      "We create responsive and robust websites that are user friendly and helps your business to flourish online. The TZ Creation understand that the importance of emerging technologies that are changing the game for online customers and users. Building a thoughtful web design for your ecommerce to maximize your reach and profitability for your business is what we do. Our ecommerce web developer ensures that your website remains market competitive, functional, customizable, and swift according to the changing needs of the ecommerce business type.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "E-commerce Website Design",
      portfolioCaption: "OUR RECENT WORK",
      portfolioImages: PortfolioImagesData.ecommercePortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: ECommercePackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "More than 50% of all online shoppers use their mobile phones to shop online. While it may be a nightmare for other platforms to be optimized to become mobile-friendly, that certainly isn’t the case for Big Commerce. Big Commerce is already adapted and maximized to feel natural in a smartphone or a table, eliminating the need for it to be explicitly optimized. It may not feel like much, but it is a huge plus point for people looking to make it easier for their customers to buy from them.",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "What We Do",
      description:
        "Our eCommerce website development services are designed to fulfill your project needs and requirement. We are always a step ahead to take rightful decisions for your ecommerce website. We provide your website the maximum exposure to enhance the conversion rate, meeting all the deadlines, and allowing you to enjoy a perfect yet functional website within your budget",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Design",
          desc: "The sole existence of our eCommerce website development services is to develop user-friendly and customer-oriented websites. Our e-commerce team follows rigorous strategies to keep your business on the top of google searches.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Develop",
          desc: "We build your websites with design-full thinking that includes creating a mock design, brand strategy, and art directions for your site. Our ecommerce website development services are tailored according to your business nature and type.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Publish",
          desc: "Your business needs to shine bright in the digital world. We can help you create websites of your choice. From minimalistic designs to complex and integrated with chatbots, your projects are always secured with us.",
        },
      ],
    },
  },
  hosting: {
    id: "s07",
    pageName: "Hosting",
    menuName: "Services",
    slug: "hosting",
    titleLine: "PROFESSIONAL",
    captionLine: "Affordable Web Hosting Service!",
    captionLine2: "",
    description: [
      "We have been providing affordable web hosting services which allows customer to safely store their complete data with excellect customer experince.",
    ],
    tagLine: ["PERFECT STARTING POINT TO"],
    bannerImg: ImageHelper.DomainHosting,
    bannerTitle: "Your dedicated Website Hosting Service",
    bannerDesc: [
      "This is what most of the new website don’t need for their sites. This type of Web hosting service is reserved for big websites that are at the enterprise-level web hosting services capabilities, as this is the domain hosting that we would be providing you in the cheap hosting package so that you won’t have any issue later in operating the website. Like the interruption in the traffic to your site when you use the shared web hosting services from some cheap hosting.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "OUR RECENT WORK",
      portfolioCaption: "Websites Hosted",
      portfolioImages: PortfolioImagesData.hostingPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "Our Services",
      description:
        "We have some professional domain hosting services that may help you not to get into different domain registrars, also because we have cheap web hosting. It is a way that you can buy the domain name and the hosting separately, but our website hosting & domain services are in the website creating packages. Shared Web hosting services is one of the popular choices of most website creators. It is one of the most affordable web hosting services and does not even require much technical knowledge to work on it.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Customers Support",
          desc: "The Web hosting services we will be providing you will be throughout the whole website process, will make you realize the importance of timely and helpful customer support. Our professional Web Hosting services won’t be any different.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Assosiated Email",
          desc: "To look professional, we will be fulfilling your need for the branded email addresses which would use your site's domain name. Whatever your domain name is when the domain is registered, you then can generate an email that has the domain name in it.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Website's Security",
          desc: "This is something that none of the new website owners think of, but it is as much important. Having complete security of your site is impossible; in our Domain hosting Services we make sure that your site stays secure from any incoming threats.",
        },
      ],
    },
  },
  logoDesign: {
    id: "s08",
    pageName: "Logo Design",
    menuName: "Services",
    slug: "logo-design",
    titleLine: "PROFESSIONAL",
    captionLine:
      "we offer custom logo designs that make your brand's logo catch the eye of the audience.",
    captionLine2: "",
    description: [
      "Being a professional logo design company, we create custom logo design online and make sure that your logo is created in such way that it stands above your competitor’s logos and becomes a memorable mascot.",
    ],
    tagLine: ["PERFECT STARTING POINT TO"],
    bannerImg: ImageHelper.LogoDesigning,
    bannerTitle: "Custom Logo Design Services",
    bannerDesc: [
      "When you see a logo, what do you think that is it just a piece of art? That is where you are wrong as it is the structure block your organization needs to build a solid brand personality with. Using a custom logo on different parts of your business, for example, site, packing, social media, label, printed materials, and so on, gets your brand the much-needed prominence. A logo becomes memorable when it exceptionally recognizes your brand from your competition. That is the motivation behind why we, being a professional logo design company, give you a custom logo designing services at the most affordable price in the market.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Recent affordable Logo Designs",
      portfolioCaption: "OUR RECENT WORK",
      portfolioImages: PortfolioImagesData.logoDesignPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: BrandingPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataLogo,
    },
    keyHighlights: {
      question: "What We Do?",
      description:
        "Our professional logo designers design the logo in this way that makes the logo alive in the minds of clients and customer. You may have heard of the phrase “The first impression is the last impression”, so to make and continue your first impression perfect, you need a fine, expertly designed logo that draws in individuals by reconnecting to your story. As being one of the best logo designing companies, we plan to dazzle the crowd’s psyches and convert the one-time customer to ones that make a significant impact on your brand primary concern.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Produce",
          desc: "Our web design & development team utilizes up-to-date coding practices with clean HTML5 and CSS3.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Analyze",
          desc: "As the market trends change continuously, our experts investigate marketing patterns and modern styles, which will make your brand come under the rundown of contemporary brands.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Develop",
          desc: "We are a professional logo design company, and we keep you involved at every step so you are never sidelined. We give your brand the certainty it needs at each stage of the design process.",
        },
      ],
    },
  },
  seo: {
    id: "s11",
    pageName: "SEO",
    menuName: "Services",
    slug: "seo",
    titleLine: "PROFESSIONAL",
    captionLine:
      "We provide the best SEO services that can help our clients in reaching unattainable heights of success.",
    captionLine2: "",
    description: [
      "Focused on giving our clients affordable search engine optimization services that can help their business grow, thereby engaging consumers in an incredible manner. Using our services can take your flight to the sky of success.",
    ],
    tagLine: ["PERFECT STARTING POINT TO"],
    bannerImg: ImageHelper.SEO,
    bannerTitle: "SEO Services",
    bannerDesc: [
      "We are a team of Search Engine Optimization experts that can provide your business engaging and well-planned content. Through the guidance of our SEO marketing experts, you can glorify your website and convert potential clients into real-time consumers. When you search ‘SEO Services Company California,’ you will always find our name on the very top. This is because of the fact that we have the will and experience to help your business websites get higher conversion rates. We provide the best SEO services, and with our help, your website can see significant growth in the conversion rate.",
    ],
    QuickAcationBtn: "Analyze Your Website",
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Recent Seo Services",
      portfolioCaption: "Our Seo Services",
      portfolioImages: PortfolioImagesData.seoPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Affordable Seo service Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "PROFESSIONAL",
      spData: SEOPackagesData,
      spShortDescription:
        "Ready to get started? Solutions devised to best suit your needs. Our SEO services are priced competitively, with packages structured around your business needs.",
      spDescription:
        "SEO professionals play a vital role in generating leads on the websites. What makes us useful in this regard is that we come up with affordable SEO services that cannot only save your cost but can also turn your website into a success story. We being experts in what we do, know how to do it, which can be really beneficial for the growth of your business.We have a track record of reducing the cost management risks by 60%. This is the SEO agency that can take your business to the place you always imagined. We do that by maximizing the prospects and reducing the weaknesses through the SEO.",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "How we Perform?",
      description:
        "We are a team of SEO professionals that provide affordable SEO services. We provide a set of services that you will need to make our business grow through different niches of digital marketing. The thing that makes us unique is the fact that we have search engine optimization experts that are known for their skills. If you are looking for SEO and marketing specialists, you have come to a perfect place.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Analyse",
          desc: "In dealing with SEO, it is important to analyse the backlinks of the website and work accordingly. Moreover, the thing that matters the most in SEO is to know the strengths and weaknesses of your competitors in the market.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Optimize",
          desc: "Optimization plays a significant role in the smooth functioning of Search Engine Optimization. We optimize for your mobile and take care of all the other parameters too that need help in terms of optimization.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Secure",
          desc: "We come with the best SEO services in this regard. We secure your content through SEO tools. We secure your data and use the structured data as per the requirement of the website. We have a team of specialists who have been dealing with website and SEO security.",
        },
      ],
    },
  },
  shopifyDevelopment: {
    id: "s12",
    pageName: "Shopify Development",
    menuName: "Services",
    slug: "shopify-development",
    titleLine: "Professionally Designed",
    captionLine: "We create unique app designs",
    captionLine2: "to help grow your reach",
    description: [
      "As a web application development company, we know the web application's objectives; we can characterize the undertaking. Web Application pages highlight the App needed to satisfy the objective and the timetable for building those out. With the extension all around characterized, we can begin delving into the sitemap, characterizing how the substance in degree definition will interrelate. Since we have a greater image of the App as a top priority, we can begin making content for the individual pages, continually keeping website streamlining (Web optimization) as a primary concern to help keep pages zeroed in on a solitary point.",
    ],
    tagLine: ["Start selling now"],
    bannerImg: ImageHelper.WebAppDevelopment,
    bannerTitle: "Custom Shopify Development",
    bannerDesc: [
      "When everything's working delightfully, it's an ideal opportunity to design and execute your web application's dispatch! This should incorporate arranging both dispatch timing and correspondence systems for the Custom web application development services, when will you dispatch, and how you might let the world know? From that point onward, it's an ideal opportunity to break out the bubbly. Contrasted with electronic web applications give an entire scope of business points of interest. These applications can be acquired from any PC through the web.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Custom Web Application designs",
      portfolioCaption: "Our App Designs",
      portfolioImages: PortfolioImagesData.shopifyDevelopmentPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: ECommercePackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "How can we create the best Shopify website for you?",
      description:
        "We have already established that Shopify is the way to go when you're looking to have your website created. But why? How can we create the best possible website for you and add our own professional touch to it to ensure that it truly is something amazing? Our Shopify Design and Development services cover each and every aspect that needs to be taken care of when creating a website. To allow you to have a better idea about what it is that we do specifically, we have highlighted some but not all of the services that we offer.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Store Design & Development",
          desc: "This, obviously, is the first and the most primal aspect of the whole development ordeal is to design the overall look and develop the general feel and features of your store. What products does it have? How do you want it to look? What services are you offering? This all is going to be answered in this phase of the development process.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Website Migration",
          desc: "You want to migrate to Shopify. Unfortunately, you already had a website created on some other platform, but now you've realized it wasn't a good fit for you. Don't worry; we've got your back! We help people migrate from a variety of different platforms to Shopify to ensure that you're getting the most out of your website.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "SEO & Internet & Marketing",
          desc: "Okay, you're done with the whole development and designing process, but what next? You need to market your website over the internet in order to attract your consumers to your website so that you can earn from it. Luckily for you, we have a whole SEO & Internet Marketing department set in place just to achieve that singular purpose!",
        },
      ],
    },
  },
  sslCertificate: {
    id: "s13",
    pageName: "SSL Certificate",
    menuName: "Services",
    slug: "ssl-certificate",
    titleLine: "SSL Protection For Anyone",
    captionLine:
      "Build Trust and Protect Your Brand with Leading Encryption, Identity & Website Security Solutions.",
    captionLine2: "",
    description: [],
    tagLine: ["Fast, Reliable and Secure"],
    bannerImg: ImageHelper.SSL,
    bannerTitle: "Secure Your Website with SSL Certificate",
    bannerDesc: [
      "Trust is everything. And, that's never been more true than in today's world, where data breaches are a constant risk. So, how do you ensure that your credibility, integrity, reputation and trustworthiness aren't at risk? Implement proper encryption, identity and security protections that users can see and feel. When consumers trust your security, they trust your brand. A trusted brand always wins—so, let's inspire trust together.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Web Design",
      portfolioCaption: "Our Web Designs",
      portfolioImages: PortfolioImagesData.sslCertificatePortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "How we Perform?",
      description:
        "We are a team of SSL professionals that provide affordable SSL services. We provide a set of services that you will need to secure your business website and will help you to build trust with your audience. The thing that makes us unique is the fact that we have Secure Sockets Layer experts that are known for their skills. If you are looking for SSL Generation for website and keep your website secure from malicious attacks, you have come to a perfect place.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Analyse",
          desc: "In dealing with SEO, it is important to analyse the backlinks of the website and work accordingly. Moreover, the thing that matters the most in SEO is to know the strengths and weaknesses of your competitors in the market.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Optimize",
          desc: "Optimization plays a significant role in the smooth functioning of Search Engine Optimization. We optimize for your mobile and take care of all the other parameters too that need help in terms of optimization.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Secure",
          desc: "We come with the best SEO services in this regard. We secure your content through SEO tools. We secure your data and use the structured data as per the requirement of the website. We have a team of specialists who have been dealing with website and SEO security.",
        },
      ],
    },
  },
  videoAnimation: {
    id: "s14",
    pageName: "Video Animation",
    menuName: "Services",
    slug: "video-animation",
    titleLine: "Artistic",
    captionLine: "Animate simple designs to bring",
    captionLine2: "liveliness to your brand",
    description: [
      "We are a one-stop explainer video company. Our video animation services are tailored to fit your brand needs. We offer animated explainer videos, 2D or 3D animations, along with doodle arts and animations. We are creative-led designing and animation services to deliver you highly engaging and appealing videos in the digital era when everyone is making animated videos, why your brand has to suffer. Keep your audience connected by showing your lively side. With us, create any videos to approach your audience and market your products. We have a dedicated and creative team to animate your ideas and thoughts.",
    ],
    tagLine: ["Guaranteed Results"],
    bannerImg: ImageHelper.videoAnimation,
    bannerTitle: "Get Higher Conversion Rate with Whiteboard Animation Video",
    bannerDesc: [
      "Most people avoid reading a long block of texts to understand a concept or to know about your company, and our explainer video company offers you a way out to this problem. We create explainer video production and start-up video production online to explain your company and services. You need to create animated videos when you are starting a new business. This helps your customer to get to know your brand. Likewise, people have a considerate attention span; they do not involve in any services that fail to entertain or attract them. Through whiteboard animation, you can talk about your services while keeping your audience involved in conversations about your brand.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Custom Video Designs",
      portfolioCaption: "OUR LIST OF PROJECTS",
      portfolioImages: PortfolioImagesData.videoAnimationPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Customized Videos" },
        { spTitle: "To Suit All Budgets" },
      ],
      spCaption: "Experienced",
      spData: VideoAnimationPackagesData,
      spShortDescription:
        "Our packages are budget-friendly without cutting corners on quality. We keep our prices low to make it easier for our clients to buy from us. Choose from any of the below mentioned affordable packages, and leave the rest to us.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "What we do for you?",
      description:
        "Animations add colors to your brand. We create appealing custom animated videos to bring liveliness to your brand message. However, we always remain consistent with your brand strategy in terms of colors, font, layout, design, and everything else that sync well with your digital needs. Moreover, animations provide your customers and target audience an effective medium to know about your expertise, services, and products. Make your message exciting so that your audience perceives it easily. We can adjust our animations according to your broader goals and objectives. First, we will craft a character that aligns well with your desire. Be it quirky, fun, playful, or serious, we will design your custom animated video accordingly.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Custom Animated Videos ",
          desc: "Our professional video animation services are incredible when it comes to creativity. We craft according to your goals and brand strategy. Whether you want your custom logo to animate or create more than minute-long animated videos, our designers and animators will bring your idea into reality.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Maximize Your Reach",
          desc: "We are ready to kick-start a project according to your prompts. Our professional video animation services and whiteboard explainer videos will help your brand achieve its target. We work on every project with full commitment and dedication. Our animated videos are liked and shared by thousands of people.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Increase Brand Awareness",
          desc: "To add high-end energy into your animations, we use dynamic and vibrant colors like magenta, orange, or yellow. We play with color psychology to make your brand vibrant, lively, welcoming, or stable. Our custom animate videos are according will incorporate key objectives without missing any key aspect.",
        },
      ],
    },
  },
  webAppDevelopment: {
    id: "s15",
    pageName: "Web App Development",
    menuName: "Services",
    slug: "web-app-development",
    titleLine: "CUSTOMIZED",
    captionLine: "We create unique app designs to help grow your reach",
    captionLine2: "",
    description: [
      "As a web application development company, we know the web application's objectives; we can characterize the undertaking. Web Application pages highlight the App needed to satisfy the objective and the timetable for building those out. With the extension all around characterized, we can begin delving into the sitemap, characterizing how the substance in degree definition will interrelate. Since we have a greater image of the App as a top priority, we can begin making content for the individual pages, continually keeping website streamlining (Web optimization) as a primary concern to help keep pages zeroed in on a solitary point.",
    ],
    tagLine: ["Target Your Audience Better"],
    bannerImg: ImageHelper.WebAppDevelopment,
    bannerTitle: "Why Create a Web-Application",
    bannerDesc: [
      "When everything's working delightfully, it's an ideal opportunity to design and execute your web application's dispatch! This should incorporate arranging both dispatch timing and correspondence systems for the Custom web application development services, when will you dispatch, and how you might let the world know? From that point onward, it's an ideal opportunity to break out the bubbly. Contrasted with electronic web applications give an entire scope of business points of interest. These applications can be acquired from any PC through the web.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Web Development",
      portfolioCaption: "Our Web Development",
      portfolioImages: PortfolioImagesData.webAppDevelopmentPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Application Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "How will you be benefited?",
      description:
        "At this point, you have every one of your pages characterized and know how they show the web application guest, so it's an ideal opportunity to ensure everything works so that when you have a web application visitor, they don't get anything that may loosen their interest. Consolidate manual perusing of the web application on gadgets with computerized web application visitors to recognize everything from client experience issues to direct broken connections.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Availability across gadgets for clients.",
          desc: "Fortunately, most work area programming can really be formed into a Web application, which implies that you can use it in any place you are, from any cell phone. This gives the client decision regarding when and where they should use the web application, advancing adaptable working inside organizations to build the general representative efficiency, these are the major perks by our Web app development experts.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Customization for various gadgets",
          desc: "Content inside Web applications can be effortlessly redone for use on different gadgets, for example, portable. This makes the web application easy to use, and charming to use since the introduction of data can be changed appropriately. Truth be told, it is really simpler to edit applications than it is for standard ones.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Coordination with different supports.",
          desc: "Web applications give a far more interesting capacity to coordinate with different frameworks than workplace applications. Confined programming is separated contrasted with Web applications which are altogether more compatible. This is because web applications can be connected together more effectively than two totally separate supports.",
        },
      ],
    },
  },
  websiteMaintance: {
    id: "s16",
    pageName: "Website Maintenance",
    menuName: "Services",
    slug: "website-maintance",
    titleLine: "PROFESSIONAL",
    captionLine:
      "Website maintenance plans for your business website to give you the best possible performance.",
    captionLine2: "",
    description: [
      "We provide you safe and protected digital experience online. Our website maintenance packages are reasonably priced when is compared to the quality of work.",
    ],
    tagLine: ["PERFECT STARTING POINT TO"],
    bannerImg: ImageHelper.websiteMaintenance,
    bannerTitle: "Our Website maintenance services",
    bannerDesc: [
      "Outperform your competitors by keeping your website well managed and maintained. You can maximize your online performance through a well-maintained site. Our services are custom made to keep your site running and useful. We run regular tests across your website and keep you updated throughout, with your site's uptime actively monitored.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Our Maintained Websites",
      portfolioCaption: "OUR RECENT WORK",
      portfolioImages: PortfolioImagesData.websiteMaintancePortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site. ",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "How will you be benefited?",
      description:
        "At this point, you have every one of your pages characterized and know how they show the web application guest, so it's an ideal opportunity to ensure everything works so that when you have a web application visitor, they don't get anything that may loosen their interest. Consolidate manual perusing of the web application on gadgets with computerized web application visitors to recognize everything from client experience issues to direct broken connections.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Availability across gadgets for clients.",
          desc: "Fortunately, most work area programming can really be formed into a Web application, which implies that you can use it in any place you are, from any cell phone. This gives the client decision regarding when and where they should use the web application, advancing adaptable working inside organizations to build the general representative efficiency, these are the major perks by our Web app development experts.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Customization for various gadgets",
          desc: "Content inside Web applications can be effortlessly redone for use on different gadgets, for example, portable. This makes the web application easy to use, and charming to use since the introduction of data can be changed appropriately. Truth be told, it is really simpler to edit applications than it is for standard ones.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Coordination with different supports.",
          desc: "Web applications give a far more interesting capacity to coordinate with different frameworks than workplace applications. Confined programming is separated contrasted with Web applications which are altogether more compatible. This is because web applications can be connected together more effectively than two totally separate supports.",
        },
      ],
    },
  },
  wooCommerceDevelopment: {
    id: "s17",
    pageName: "Woo Commerce Development",
    menuName: "Services",
    slug: "woo-commerce-development",
    titleLine: "Great Attention To Detail",
    captionLine:
      "Have your website designed on Woocommerce, and let us worry about everything else!",
    captionLine2: "",
    description: [
      "Woocommerce is the mark of quality and easy accessibility for those in the website design and development industry!",
    ],
    tagLine: ["Tailored Designs for your brand"],
    bannerImg: ImageHelper.AboutImage,
    bannerTitle: "Custom Woo commerce Development",
    bannerDesc: [
      "Are you looking to refresh your website and give it a whole new look and feel? Want to design something entirely made from scratch? If the answer to both of the questions asked above is yes, then look no further, you’ve come to the right place! We create custom-tailored designs made according to your specifications while also making sure that the customer experience is as transparent and as prompt as possible.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Custom Web Application designs",
      portfolioCaption: "Our App Designs",
      portfolioImages: PortfolioImagesData.wooCommerceDevelopmentPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Web Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: ECommercePackagesData,
      spShortDescription:
        "Are you convinced yet? If not then you surely would be after you take a look at our packages. We offer extremely market competitive prices that are easier on our customers. This helps us satisfy all your needs the best way we can.",
      spDescription:
        "In order to stay relevant in the modern world, you need to first understand how it works and then make sure that you’re doing everything that you can to align your practices with it. Creating a Woocommerce website is your first step toward achieving that very goal. With the help of the industry’s most experienced professionals, we reanimate your ideas back to life which results in a positive user experience for everyone involved.",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "What are some of the services that we offer?",
      description:
        "Our services portfolio spans far and wide, and we offer anything and everything that a customer might need when it comes to designing a Woocommerce website. TZ Creation does this to ensure that all our client’s needs are being fulfilled under one roof. This, in turn, contributes towards a healthier customer service experience for all our clients. Some of the services relating to Woocommerce development are listed as follows.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Woocommerce Designing",
          desc: "Woocommerce offers a variety of customization options that help give your website a more personal touch along with setting yourself apart from the rest of your competition. If you want us to, we will create your designs from scratch and include a fixed number of revision rounds, agreed upfront, so that, in the end, you have something that you’re truly satisfied with.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Woocommerce Migration",
          desc: "If you have a currently functioning website but want to switch to Woocommerce because you’re thinking of upgrading for a platform that offers a wider range of versatility, we’ll help you do that too! No need to worry about the loss of data or anything like that. We will migrate your website while keeping what’s at its core intact.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Woocommerce different Integration",
          desc: "If you’re looking to automate your Woocommerce website to a certain degree (automated payments, deliveries, inventory management), we can help you do that too. With the help of our amazing team, you can rest easy while knowing that everything is being taken care of. All you have to do is reach out to us, and we’ll take it from there.",
        },
      ],
    },
  },
  wordpressWebsite: {
    id: "s18",
    pageName: "Wordpress Website",
    menuName: "Services",
    slug: "wordpress-website",
    titleLine: "PROFESSIONAL",
    captionLine: "Modern WordPress Websites creators for your digital needs.",
    captionLine2: "",
    description: [
      "We build and design WordPress websites at your will. Our WordPress Website Design service helps you engage your audience digitally.",
    ],
    tagLine: ["PERFECT STARTING POINT TO"],
    bannerImg: ImageHelper.WeOffer,
    bannerTitle: "Custom WordPress Web Design Services.",
    bannerDesc: [
      "Our WordPress Development Company who has been providing WordPress website development services for years. Our process is convenient and customized, according to the client. Whether you want to design a website from scratch or need to redesign your existing website. Just ask us, and we will provide you with a seamless experience. Our WordPress web design agency has a perfect strategy to work on every type and audience's websites. Modern, classic, exquisite, or exceptional designs, we have the expertise to make you stand out from the digital crowd.",
    ],
    pageModIntro: [
      {
        title: "CSS & CSS Frameworks",
        description:
          "Our specialty lies in delivering the refined web solutions by using the latest CSS frameworks that often promote code reuse to speed up workflow without sacrificing any functionality. For instance, you can pick from Bootstrap, Materialized CSS and make perfect use of CSS preprocessors like SCSS/SASS & LESS.",
      },
      {
        title: "Javascript Implementation",
        description:
          "It is an easy go task for us to deliver the feature-rich web designs featuring the latest trends and concepts of JavaScript. We use the popular technological tactics such as Parallax animation & custom animations to provide best custom solutions. We ultimately want to transform your designs into an interactive code.",
      },
      {
        title: "Responsive & Retina Ready",
        description:
          "Our technology geeks are brilliant in creating results from the new technologies and ensure that your responsive web design looks perfect for every available browser and device. The ultimate motto is to create an uncluttered user experience by proper content adjustment no matter which device your viewers use.",
      },
    ],
    portfolioSlider: {
      portfolioTitle: "Custom Wordpress Website designs",
      portfolioCaption: "OUR RECENT WORK",
      portfolioImages: PortfolioImagesData.wordpressWebsitePortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Wordpress Website Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "PROFESSIONAL",
      spData: WebDesignPackagesData,
      spShortDescription:
        "Ready to get started? Solutions devised to best suit your needs. Our WordPress website service is priced competitively, with packages structured around your business needs.",
      spDescription:
        "Your website design needs to stay different and to appear different to gain the attention of your audience. The same cookie-cutter website designs make your business look cheap and unresponsive. Hence visitors don’t convert into clients. Whether you are an entrepreneur, businessman, or a student, your WordPress website needs to reflect your personality. We will help you choose the perfect design the lets your personality shine. Gain the attention you and your business deserve and engage your audience digitally. We ensure that your website remains your visitors' top priority, and they keep coming back to your site.",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our websites",
      servicePortfolioCaption: "OUR website PORTFOLIO",
      servicePortfolioData: PortfolioDataWeb,
    },
    keyHighlights: {
      question: "What We Do?",
      description:
        "In this digital age, your WordPress website is your remote office. No matter where you live and how you live, all that matters is how you portray your business in front of the audience and customers alike. If you are unable to get the attention of your audience for some reason, you are losing in the game of business. Therefore, your WordPress website deserves respect. We provide you with assistance to bring drastic changes in how you appear online. With us, get the attention you require to become great and successful again.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "Smooth Experience",
          desc: "Our web design & development team utilizes up-to-date coding practices with clean HTML5 and CSS3.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "Wordpress Developers",
          desc: "Our WordPress web developers are masters of their field. They hold the experience to work on any idea regardless of its complexities. We believe in providing high-end products. Thereby, we appreciate and take pride in your skilled developers.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "Safe Migration",
          desc: "Our WordPress Development Company assures you safe and protected migration services from your current domain. We ensure that your data do not get a leak or get lost during the migration process during this whole time.",
        },
      ],
    },
  },
  uiUxDesign: {
    id: "s19",
    pageName: "UI/UX Design",
    menuName: "Services",
    slug: "ui-ux-design",
    titleLine: "CREATIVE",
    captionLine:
      "we design intuitive, user-first interfaces that turn visitors into customers.",
    captionLine2: "",
    description: [
      "Good design is invisible - it just works. Our UI/UX design process starts with how real people actually use a product, not just how it looks. From wireframes to fully interactive prototypes, we build interfaces that are simple to navigate, consistent across devices, and designed around what your users are actually trying to do.",
    ],
    tagLine: ["DESIGNED AROUND YOUR"],
    bannerImg: ImageHelper.BidroidNewUI,
    bannerTitle: "UI/UX Design Services",
    bannerDesc: [
      "Whether you're building a product from scratch or redesigning something that isn't converting, our UI/UX team maps out the user journey first and designs second. That means fewer confused users, fewer drop-offs, and an interface that actually supports your business goals instead of just looking nice in a mockup.",
    ],
    portfolioSlider: {
      portfolioTitle: "Recent UI/UX Projects",
      portfolioCaption: "OUR RECENT WORK",
      portfolioImages: PortfolioImagesData.uiUxDesignPortfolio,
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our design studio",
      servicePortfolioCaption: "OUR UI/UX PORTFOLIO",
      servicePortfolioData: PortfolioDataUiUx,
    },
    keyHighlights: {
      question: "What We Do?",
      description:
        "We design digital products people actually enjoy using - from the first wireframe through to a polished, ready-to-build interface. Every screen is designed with a reason behind it, not just to fill space.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Research",
          desc: "Before any screen gets designed, we look at who's using the product and what they're trying to get done, so the design solves a real problem instead of guessing at one.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Wireframe",
          desc: "We map out layout, flow, and structure early, so the big decisions about navigation and usability are made before any visual design work begins.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Design & Prototype",
          desc: "From high-fidelity visuals to clickable prototypes, we hand off designs that are ready to build - clear, consistent, and tested against how people actually click through them.",
        },
      ],
    },
  },
  adsDesign: {
    id: "s20",
    pageName: "Ads Design",
    menuName: "Services",
    slug: "ads-design",
    titleLine: "IMPACTFUL",
    captionLine:
      "we design ad creatives and banners built to stop the scroll and get noticed.",
    captionLine2: "",
    description: [
      "An ad has a fraction of a second to earn attention. We design banners, social ad creatives, and promotional graphics that are built around a single clear message, so they work whether they're seen on a phone screen or a billboard.",
    ],
    tagLine: ["CREATIVE MADE FOR"],
    bannerImg: ImageHelper.CricBuzzBanner,
    bannerTitle: "Ads & Promotional Design Services",
    bannerDesc: [
      "From social media ad creatives to banners, infographics, and campaign graphics, we design promotional material that's built to match your brand and hold attention just long enough to make an impression. Every piece is designed to support the actual goal of the campaign, not just fill a placement.",
    ],
    portfolioSlider: {
      portfolioTitle: "Recent Ad Creatives",
      portfolioCaption: "OUR RECENT WORK",
      portfolioImages: PortfolioImagesData.adsDesignPortfolio,
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our design studio",
      servicePortfolioCaption: "OUR ADS PORTFOLIO",
      servicePortfolioData: PortfolioDataPoster,
    },
    keyHighlights: {
      question: "What We Do?",
      description:
        "We design the ad creatives, banners, and promotional graphics that carry your campaigns - built to be quick to read, on-brand, and effective across the platforms you actually run them on.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Plan",
          desc: "We start with the campaign's actual goal and platform, so the creative is built for where it's going to run rather than resized after the fact.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Design",
          desc: "Clear hierarchy, strong visuals, and a message that reads in seconds - built to match your brand across banners, social ads, and print promotional pieces alike.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Deliver",
          desc: "Every creative comes ready in the sizes and formats you need, so there's no back-and-forth resizing before a campaign can go live.",
        },
      ],
    },
  },
  stationeryDesign: {
    id: "s21",
    pageName: "Stationery Design",
    menuName: "Services",
    slug: "stationery-design",
    titleLine: "PROFESSIONAL",
    captionLine:
      "we design branded packaging, print collateral, and stationery that look as good as your business is.",
    captionLine2: "",
    description: [
      "Product packaging, book covers, certificates, and printed collateral are often the first physical thing a client holds from your business. We design branded print material that stays consistent with your visual identity, so every touchpoint - digital or printed - feels like the same brand.",
    ],
    tagLine: ["PRINT DESIGNED FOR"],
    bannerImg: ImageHelper.Other4,
    bannerTitle: "Stationery & Print Design Services",
    bannerDesc: [
      "From product packaging and book covers to certificates and branded vouchers, we design printed collateral that's consistent with your visual identity. It's design work meant to be held, not just viewed on a screen - so we pay close attention to how it'll actually look printed.",
    ],
    portfolioSlider: {
      portfolioTitle: "Recent Print & Stationery Work",
      portfolioCaption: "OUR RECENT WORK",
      portfolioImages: PortfolioImagesData.stationeryDesignPortfolio,
    },
    servicePackages: {
      spTitle: [
        { spTitle: "Stationery Design Packages" },
        { spTitle: "For Any Budget" },
      ],
      spCaption: "Cost-Effective",
      spData: CollateralPackagesData,
      spShortDescription:
        "Every package below includes two stationery design sets, with more print collateral added as the package grows.",
      spDescription:
        "Stationery is how your brand shows up in a client's hands: business cards, letterheads and envelopes that look like they belong together. Pick the package that matches the print collateral you need today. If you need something that is not listed, contact us and we will scope it with you.",
    },
    servicePortfolio: {
      servicePortfolioTitle: "Fresh from our design studio",
      servicePortfolioCaption: "OUR PRINT PORTFOLIO",
      servicePortfolioData: PortfolioDataOther,
    },
    keyHighlights: {
      question: "What We Do?",
      description:
        "We design the printed and branded materials that represent your business in the physical world - built to match your existing brand identity and hold up in print, not just on-screen.",
      points: [
        {
          icon: IconHelper.serviceicn1,
          point: "We Plan",
          desc: "We work from your existing brand identity - colors, fonts, and logo - so every printed piece feels consistent with everything else you put out.",
        },
        {
          icon: IconHelper.serviceicn2,
          point: "We Design",
          desc: "From product packaging to certificates and branded vouchers, we design layouts that are clean, on-brand, and built correctly for print from the start.",
        },
        {
          icon: IconHelper.serviceicn3,
          point: "We Prepare for Print",
          desc: "Every file is delivered print-ready - correct color profiles, bleed, and resolution - so there are no surprises at the printer.",
        },
      ],
    },
  },
};

export default ServicesPageData;
